import { Suspense } from "react";
// GLOBAL CUSTOM COMPONENTS
import ExpLoading from "app/components/ExpLoading";

export default function ExpSuspense({ children }) {
	return <Suspense fallback={<ExpLoading />}>{children}</Suspense>;
}
